import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'
import store from '@/store';

let routes: RouteRecordRaw[] = [
    {
        path: '/license',
        name: 'license',
        component: () => import("./views/license.vue"),
        beforeEnter: (to, from, next) => {
            if(!store.state.subscription){
                next('/license/plans');
            } else {
                next();
            }
        },
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/license/plans',
        name: 'licensePlans',
        component: () => import("./views/plans.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/requestPlan/:planIdentifier',
        name: 'requestPlan',
        component: () => import("./views/requestPlan.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
];

export default routes;
